import jwt from 'jsonwebtoken';
import { parse } from 'cookie';

export const getPayloadCookie = (name: string, context) => {
  const parseCookies = context && parse(context);
  const idToken = parseCookies && parseCookies[name];
  const payload = idToken && jwt.decode(idToken);

  return payload;
};
